import React, { useEffect, useState } from "react";
import "../../views/App/App.css";
import preloaderImg from "../../assets/images/logo.png";
import Container from "../../components/Container";
import { commercialContent } from "../../content/commercialContent";
import SecondHeader from "../../components/SecondHeader";
import CommercialSection from "../../components/CommercialSection/CommercialSection";
import Header from "components/Header/Header";
import MobileHeader from "components/MobileHeader";
import ModalForm from "components/ModalForm";
import Footer from "../../components/Footer";

const Commercial = () => {
  const [preloader, setPreloader] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setPreloader(false);
    }, 2000);
  }, []);

  if (preloader) {
    return (
      <div className="preloader">
        <img className="preloader__img" src={preloaderImg} alt="Loading..." />
      </div>
    );
  }

  return (
    <>
      <Header />
      <MobileHeader />
      <Container>
        <SecondHeader headerText={commercialContent.header} />
        <CommercialSection data={commercialContent.firstSection} />
        <CommercialSection data={commercialContent.secondSection} />
        <CommercialSection data={commercialContent.thirthSection} />
        <ModalForm />
      </Container>
      <Footer />
    </>
  );
};

export default Commercial;
